import { TaskPanel } from '@/components/tasks';
import { useAuth } from '@/contexts/AuthContext';
import { useClinic } from '@/contexts/ClinicContext';

const TasksPage = () => {
  const { user } = useAuth();
  const { clinic } = useClinic();

  if (!user?.practitionerId) {
    return null;
  }

  return (
    <div className="p-6">
      <TaskPanel providerId={user.practitionerId} clinicId={clinic?.id} />
    </div>
  );
};

export default TasksPage;
